import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const SpecialFeatures = ({ onSpecialFeaturesSelected }) => {
  const [selectedSpecialFeatures, setSelectedSpecialFeatures] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.specialfeatures) {
        const specialFeaturesObject = firstResult.specialfeatures;
        if (specialFeaturesObject.trim() !== "") {
          setVariations(specialFeaturesObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleSpecialFeaturesClick = (specialfeatures) => {
    setSelectedSpecialFeatures(specialfeatures);
    onSpecialFeaturesSelected(specialfeatures);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Special Features:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedSpecialFeatures === variation ? "selected" : ""}`}
            onClick={() => handleSpecialFeaturesClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default SpecialFeatures;
